import { api } from './client';
import type { DiscordWebhook, DiscordTemplate } from '../types/discord';

export const listWebhooks = (): Promise<DiscordWebhook[]> =>
  api.get<DiscordWebhook[]>('/discord/webhooks').then((r) => r.data);

export const createWebhook = (data: {
  name: string;
  url: string;
  channel: string;
  server: string;
}): Promise<DiscordWebhook> =>
  api.post<DiscordWebhook>('/discord/webhooks', data).then((r) => r.data);

export const updateWebhook = (
  id: string,
  data: Partial<{ name: string; url: string; channel: string; server: string; active: boolean }>,
): Promise<DiscordWebhook> =>
  api.patch<DiscordWebhook>(`/discord/webhooks/${id}`, data).then((r) => r.data);

export const deleteWebhook = (id: string): Promise<void> =>
  api.delete(`/discord/webhooks/${id}`).then(() => undefined);

export const testWebhook = (
  id: string,
  content: string,
): Promise<{ success: boolean; error?: string }> =>
  api.post<{ success: boolean; error?: string }>(`/discord/webhooks/${id}/test`, { content }).then((r) => r.data);

export const listTemplates = (): Promise<DiscordTemplate[]> =>
  api.get<DiscordTemplate[]>('/discord/templates').then((r) => r.data);

export const createTemplate = (data: {
  name: string;
  trigger: string;
  webhookId: string;
  description?: string;
  template: string;
  active?: boolean;
}): Promise<DiscordTemplate> =>
  api.post<DiscordTemplate>('/discord/templates', data).then((r) => r.data);

export const updateTemplate = (
  id: string,
  data: Partial<{
    name: string;
    trigger: string;
    webhookId: string;
    description: string;
    template: string;
    active: boolean;
  }>,
): Promise<DiscordTemplate> =>
  api.patch<DiscordTemplate>(`/discord/templates/${id}`, data).then((r) => r.data);

export const deleteTemplate = (id: string): Promise<void> =>
  api.delete(`/discord/templates/${id}`).then(() => undefined);

export const sendTemplate = (
  id: string,
  variables: Record<string, string>,
): Promise<{ success: boolean; error?: string }> =>
  api
    .post<{ success: boolean; error?: string }>(`/discord/templates/${id}/send`, { variables })
    .then((r) => r.data);
